module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MemberBirthdayView.js"));
	}, "MemberBirthdayView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MemberBirthdayView!./src/pages/Shop/Home/MemberBirthday/MemberBirthdayView.js
// module id = 916
// module chunks = 438